import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { makeStyles } from '@material-ui/core/styles';
import colors from '../../foundations/colors.module.scss';
import typography from '../../foundations/typography.module.scss';
import { menuStyles } from '../Menu/Menu.styles';
export const skinToColor = {
    standard: colors.dark900,
    primary: colors.purple800
};
const baseFont = {
    fontFamily: typography.fontFamilyBold,
    fontSize: typography.fontSizeP1
};
const errorColor = colors.red950;
const disabledColor = colors.dark500;
const placeholderColor = colors.dark400;
export const useInlineSelectStyles = makeStyles({
    root: {
        width: undefined,
        verticalAlign: 'middle',
        '& .MuiSelect-select': {
            backgroundColor: 'transparent'
        }
    },
    inputRoot: (param)=>{
        let { color, isMobileDevice } = param;
        return _object_spread_props(_object_spread({}, baseFont), {
            color,
            // Disable input type=number arrows in Chrome, Safari, Edge, Opera
            '& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
                '-webkit-appearance': 'none',
                margin: 0
            },
            '&.Mui-error': {
                color: errorColor,
                '& $icon': {
                    color: errorColor
                }
            },
            // Disable input type=number arrows in Firefox
            '& input[type=number]': {
                '-moz-appearance': 'textfield'
            },
            '&.Mui-error:hover': {
                color: errorColor
            },
            '&.Mui-disabled': {
                color: disabledColor
            },
            '&.MuiInput-underline': {
                '&&&:before': {
                    border: 'none',
                    right: '16px',
                    bottom: '4px'
                },
                '&&&:hover:before': {
                    borderBottom: '1px solid',
                    bottom: isMobileDevice ? '2px' : '4px'
                },
                '&&&.Mui-error:hover:before': {
                    borderBottom: '1px solid',
                    borderBottomColor: errorColor,
                    bottom: isMobileDevice ? '2px' : '4px'
                },
                '&&:after': {
                    border: 'none',
                    right: '16px',
                    bottom: '4px'
                }
            }
        });
    },
    inputInput: (param)=>{
        let { color } = param;
        return _object_spread_props(_object_spread({}, baseFont), {
            padding: 0,
            lineHeight: typography.lineHeightP1,
            height: typography.lineHeightP1,
            '&::placeholder': _object_spread_props(_object_spread({}, baseFont), {
                color
            }),
            '&:-webkit-autofill': _object_spread_props(_object_spread({}, baseFont), {
                color
            }),
            '&:autofill': _object_spread_props(_object_spread({}, baseFont), {
                color
            }),
            '&.MuiSelect-select': {
                lineHeight: typography.lineHeightP1,
                paddingRight: '16px',
                minWidth: 0
            }
        });
    },
    menu: _object_spread({
        maxHeight: (props)=>props.menuMaxHeight,
        maxWidth: (props)=>props.menuMaxWidth
    }, menuStyles),
    selectPlaceholder: {
        color: placeholderColor
    },
    icon: (param)=>{
        let { color } = param;
        return {
            flexShrink: 0,
            color,
            cursor: 'pointer',
            transition: 'transform 150ms ease',
            transformOrigin: '50% 50%',
            position: 'absolute',
            right: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            '&.MuiSelect-iconOpen': {
                transform: 'translateY(-50%) rotate(-180deg)'
            }
        };
    }
});
